import { IFloorPlanModel } from '@api/models';
import { EllipsisHorizontalIcon } from '@icon/index';
import { Dropdown, DropdownItem, DropdownList, DropdownTrigger } from '@library/dropdown';
import { formatDatetime } from '@utils/date-utils';
import { GalleryCard, Img } from 'modules/shared/features/content';
import TzDateFormatter from 'modules/shared/helpers/TzDateFormatter';
import { Link } from 'react-router-dom';

interface IFloorPlanCardProps {
    floorPlan: IFloorPlanModel | any;
    onEditClick: () => void;
    onDeleteClick?: (floorPlan: IFloorPlanModel) => void;
}

const FloorPlanCard = (props: IFloorPlanCardProps) => {
    const { floorPlan, onEditClick, onDeleteClick } = props;

    return (
        // <Link to={`${floorPlan._id}/site-walk`}>
        <GalleryCard className="cursor-pointer">
            <GalleryCard.ActionBar>
                {/* {hasPermission(PermissionEnum.TIMELAPSE_CAMERA_UPDATE) && ( */}
                <Dropdown placement="bottom-end">
                    <DropdownTrigger className="w-6 h-6 grid place-items-center rounded-[4px] bg-floating-color image-overlay-button-shadow hover-transition hover:brightness-90">
                        <EllipsisHorizontalIcon className="text-grayscale-600" />
                    </DropdownTrigger>

                    <DropdownList className="min-w-[100px]">
                        <DropdownItem onClick={onEditClick}>Edit</DropdownItem>
                        <DropdownItem onClick={() => onDeleteClick(floorPlan)} className="text-danger">
                            Delete
                        </DropdownItem>
                    </DropdownList>
                </Dropdown>
                {/* )} */}
            </GalleryCard.ActionBar>
            <GalleryCard.Media>
                <Img className="w-full aspect-image rounded-lg object-cover object-center" src={floorPlan.imageUrl} />
            </GalleryCard.Media>
            <GalleryCard.Title className="">{floorPlan.name}</GalleryCard.Title>
            <GalleryCard.Footer>
                <div className="flex flex-wrap gap-4 justify-between">
                    <GalleryCard.FooterItem
                        label="Last Site Walk on"
                        content={
                            floorPlan?.latestSiteWalk?.date
                                ? formatDatetime(floorPlan?.latestSiteWalk?.date, 'DD MMM, YYYY')
                                : '-'
                        }
                    />
                    <GalleryCard.FooterItem
                        label="Uploaded on"
                        content={<TzDateFormatter date={floorPlan.createdAt} format={'DD MMM, YYYY'} />}
                    />
                </div>
            </GalleryCard.Footer>
        </GalleryCard>
        // </Link>
    );
};

export default FloorPlanCard;
